import { render, staticRenderFns } from "./D008.vue?vue&type=template&id=ada85ca8&scoped=true&"
import script from "./D008.vue?vue&type=script&lang=js&"
export * from "./D008.vue?vue&type=script&lang=js&"
import style0 from "./D008.vue?vue&type=style&index=0&id=ada85ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada85ca8",
  null
  
)

export default component.exports